import React from 'react';
import utils from 'utils';
import { useForm } from 'form';
import { Button, ErrorMessage } from 'components';
import { fb, validators } from 'form';

export function VariantAttributeOptionEdit({ attr, attrOpt, onSave, onCancel }) {
  const isEdit = attrOpt && attrOpt.id;
  const model = getEditModel(attrOpt || {});
  const form = useForm(model, {});

  const render = (name) => form.renderControl(name);

  function save(e) {
    form.validateForm(e, () => {
      const value = { ...form.getValue() };
      onSave(value)
    })
  }

  return (
    <div className="editor" style={{ margin: '10px 0', padding: '10px', background: '#ddd' }}>
      <section>
        <div className="row">
          <div className="col-md-6">{render('value')}</div>
          <div className="col-md-6">{render('displayName')}</div>
        </div>
        <div className="row">
          <div className="col-12 actions">
            <ErrorMessage errors={form.errors} />
            <Button className="btn-sm" onClick={save} status={form.status}>{isEdit? 'Update' : 'Add'}</Button>
            <Button className="btn-sm" onClick={onCancel} btnStyle="outline-dark">Cancel</Button>
          </div>
        </div>
      </section>
    </div>
  );
}

function getEditModel(data) {

  const model = fb.group({
    id: [data.id || utils.random.shortId(), { type: 'hidden' }],
    value: [data.value || '', [validators.Required()], { type: 'text', helpText: 'e.g., S, M, L, XL' }],
    displayName: [data.displayName || '', [], { type: 'text', helpText: 'If empty, Value will be used for Display Name' }]
  })

  return model;
}
